<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button parkourBackButton />
    </ion-buttons>

    <ion-title>{{ 'profiel.mijn-profiel-page.title' | translate }}</ion-title>

    <ion-buttons slot="end">
      <parkour-header-action
        [label]="'profiel.mijn-profiel-page.profiel-edit' | translate"
        [link]="['wijzig']"
        form="doel-edit-form"
        icon="edit"
        testId="edit"
      />
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-refresher [parkourRefresh]="onPageRefresh" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <parkour-page-layout>
    <ng-container *parkourPageContent="mainPageData$ | async; refresh: onPageRefresh; let data">
      <div class="container-1-col">
        <parkour-profiel-details [profiel]="data.profiel">
          <parkour-contact-methode-niet-geverifieerd-card warningContent />
          @if (data.profiel.status === 'ACTIEF') {
            <parkour-profiel-select
              typeContent
              (createPersoonlijkProfiel)="onCreatePersoonlijkProfiel()"
              (createProfessioneelProfiel)="createProfessioneelProfiel()"
              (profielSelect)="onProfielSelect($event)"
              [currentProfiel]="data.profiel"
              [profielen]="data.mijnProfielen"
              [profielCreateOptions]="data.profielCreateOptions"
            />
          }
          <ng-container topCardContent>
            @if (data.profiel.status === 'ACTIEF') {
              <parkour-profiel-qr-code-button [profiel]="data.profiel" />
            }
            @if (
              data.profiel.type === 'PROFESSIONEEL_TEAMLID' &&
              data.profiel.verificatieStatus !== 'GEVERIFIEERD'
            ) {
              <parkour-profiel-details-card
                icon="badge-on"
                backgroundColor="bg-n-300"
                title="Professioneel profiel niet geverifieerd"
              >
                We kunnen je professioneel profiel niet verifiëren via de systemen van Opgroeien.
                Als we je hoedanigheid van professionele begeleider later nog kunnen bevestigen
                voegen we een badge toe aan je profiel.
              </parkour-profiel-details-card>
            }
            @if (data.profiel.status === 'ACTIEF') {
              <parkour-profiel-details-afwezigheid-card [afwezigheid]="data.profiel.afwezigheid" />
            }
          </ng-container>
          @if (data.profiel.email || data.profiel.telefoonnummer) {
            <parkour-profiel-details-card
              bottomCardContent
              icon="eye-off"
              backgroundColor="bg-n-300"
              [title]="'profiel.prive-informatie-titel' | translate"
            >
              <ul class="space-y-4">
                @if (data.profiel.email) {
                  <li>
                    <parkour-profile-details-list-item
                      [detail]="data.profiel.email"
                      [label]="'profiel.emailadres' | translate"
                      data-testid="emailadres"
                    />
                  </li>
                }
                @if (data.profiel.telefoonnummer) {
                  <li>
                    <parkour-profile-details-list-item
                      [detail]="data.profiel.telefoonnummer"
                      [label]="'profiel.telefoonnummer' | translate"
                      data-testid="telefoonnummer"
                    />
                  </li>
                }
              </ul>
            </parkour-profiel-details-card>
          }
        </parkour-profiel-details>
      </div>
    </ng-container>
  </parkour-page-layout>
</ion-content>
